module.exports = __webpack_public_path__ + "static/media/warning.ca3741b4.svg";